$(function () {
  if (
    sessionStorage.getItem("account_text_box_dropdown_displayed") === "true"
  ) {
    $(".account-text-box-dropdown-wrapper").addClass("hide");
    sessionStorage.setItem("account_text_box_dropdown_hide", true);
  }

  if (sessionStorage.getItem("account_text_box_dropdown_hide") === null) {
    $(".account-text-box-dropdown-wrapper").removeClass("hide");
    sessionStorage.setItem("account_text_box_dropdown_displayed", true);
  }
});

$(".account-text-box-dropdown__close").on("click", function () {
  $(this).closest(".account-text-box-dropdown-wrapper").addClass("hide");
  sessionStorage.setItem("account_text_box_dropdown_hide", true);
  sessionStorage.removeItem("account_text_box_dropdown_displayed");
});
